import { getIcons } from './getIcons';
import getQAPI from './getQAPI';
import isEmptyChildren from './isEmptyChildren';
export default {
  getIcons: getIcons,
  getQAPI: getQAPI,
  isEmptyChildren: isEmptyChildren
};